import { Button, useNotify, useRefresh } from "react-admin";
import ClearIcon from "@mui/icons-material/Clear";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";

const RemoveSeatDialog = ({ campaignId, seatId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleConfirm = async () => {
    await dataProvider.customRequest(doctoralRequests.removeCampaignSeat(campaignId, seatId), null, "DELETE");
    notify("Мястото е премахнато успешно", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      titleContent="Премахни място от кампанията"
      onConfirm={handleConfirm}
      message="Сигурни ли сте, че искате да премахнете това място от кампанията?"
      triggerButton={
        <Button
          label=""
          startIcon={<ClearIcon />}
          variant="text"
          color="error"
        />
      }
    />
  );
};

export default RemoveSeatDialog;
